module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#premium",
      toString: function () {
        return this.url;
      }
    }